import {
  MDBAnimation,
  MDBCard,
  MDBCardBody,
  MDBCol,
  MDBContainer,
  MDBRow,
} from "mdbreact";
import Header from "./header";
import Body from "./body";
import "./style.css";

const BridgeDownloads = () => {
  return (
    <MDBContainer fluid className="mt-3">
      <MDBRow>
        <MDBCol md="12">
          <MDBAnimation type="fadeIn">
            <MDBCard className="bridge-downloads-card">
              <Header />
              <MDBCardBody>
                <Body />
              </MDBCardBody>
            </MDBCard>
          </MDBAnimation>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default BridgeDownloads;
